import { i18n } from "@bundles/UIAppBundle/i18n";
import phrases from "./config/ClientRequestRelatedContacts.i18n.json";
import { phrasesFr } from "./config/ClientRequestRelatedContacts.fr.i18n";
i18n.push(phrases, phrasesFr);
// You can override additional messages here by using i18n.push();
